import React, { useEffect, useRef } from 'react';
import './MaintenancePage.css';
import { fetchMaintenanceEnabled } from '../siteMaintenance';

const envMaintenanceOn = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
const publicUrl = process.env.PUBLIC_URL || '';
const maintenanceBg = `${publicUrl}/img/mantenimiento.jpg`;
const logoWhite = `${publicUrl}/img/logo.png`;

const MaintenancePage: React.FC = () => {
  const pollRef = useRef<number | null>(null);

  useEffect(() => {
    pollRef.current = window.setInterval(() => {
      fetchMaintenanceEnabled()
        .then((on) => {
          if (!on && !envMaintenanceOn) {
            window.location.reload();
          }
        })
        .catch(() => {});
    }, 20000);
    return () => {
      if (pollRef.current != null) window.clearInterval(pollRef.current);
    };
  }, []);

  return (
    <main className="maintenance-page" role="main">
      <div
        className="maintenance-page__bg"
        style={{ backgroundImage: `url(${maintenanceBg})` }}
        aria-hidden="true"
      />
      <div className="maintenance-page__overlay" aria-hidden="true" />

      <header className="maintenance-header">
        <img
          className="maintenance-logo"
          src={logoWhite}
          alt="Surf Lanzarote"
          width={320}
          height={120}
        />
      </header>

      <div className="maintenance-content">
        <h1 className="maintenance-headline">
          Estamos realizando tareas de mantenimiento · We are currently performing maintenance
        </h1>

        <p className="maintenance-sub">Vuelve en breve · We&apos;ll be back shortly</p>

        <p className="maintenance-contact-intro">Para cualquier consulta · For any queries</p>

        <div className="maintenance-contact-block">
          <a className="maintenance-link maintenance-link--email" href="mailto:info@surfphotolanzarote.com">
            info@surfphotolanzarote.com
          </a>
          <a className="maintenance-link maintenance-link--phone" href="tel:+34622046042">
            +34 622 046 042
          </a>
        </div>
      </div>
    </main>
  );
};

export default MaintenancePage;
